import React, { useState } from 'react';
import { DownloadIcon } from '@heroicons/react/outline';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import map from 'lodash/map';
import Button from '../../Button';
import { guardAsync } from '../../../utils/hooks/useInFlight';
import DocumentRow, {
  formatCompletedAt,
  joinDocumentParts,
} from './DocumentRow';

const noop = () => {};

const CustomPDF = ({
  title,
  projectName,
  milestoneName,
  completedAt,
  answersSheets,
  onDownload,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [downloading, setDownloading] = useState(false);

  const handleOnDownload = () => {
    setDownloading(true);
    return guardAsync(onDownload, () => setDownloading(false));
  };

  const questionnaireNames = map(answersSheets, 'questionnaireId').filter(
    Boolean,
  );

  return (
    <DocumentRow
      primaryLine={joinDocumentParts([
        title,
        milestoneName,
        questionnaireNames.join(', '),
      ])}
      secondaryLine={formatCompletedAt({
        t,
        language,
        completedAt,
      })}
      tertiaryLine={projectName}
      actions={
        onDownload && (
          <Button
            icon={<DownloadIcon />}
            loading={downloading}
            onClick={handleOnDownload}
          >
            {downloading ? t('downloading') : t('download')}
          </Button>
        )
      }
    />
  );
};

CustomPDF.propTypes = {
  title: PropTypes.string.isRequired,
  projectName: PropTypes.string,
  milestoneName: PropTypes.string,
  completedAt: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
  ]),
  answersSheets: PropTypes.array,
  onDownload: PropTypes.func,
};

CustomPDF.defaultProps = {
  projectName: null,
  milestoneName: null,
  completedAt: null,
  answersSheets: [],
  onDownload: noop,
};

export default CustomPDF;
